$(document).ready(function() {
  // Prevent double form submissions
  $("form").submit(() => {
    $(this)
      .find("button[type='submit']")
      .prop("disabled", true);
  });
});
